export default __webpack_public_path__ + "static/media/bg-front.5c43a06f.png";